import { useMemo } from "react";
import {
  AditusType,
  AspType,
  ExpoPlatformType,
  JetType,
  SitkaType,
  VisitType,
} from "@evennt-tech/api-v2-core";
import { ExternalControlType } from "view/components/RichTextEditor/controls/externalControl";
import filterNotEmptyArray from "tools/common/filterNotEmptyArray";
import { useCurrentPublicShow } from "hooks";
import useJet from "hooks/show/jet/useJet";

type Args = {
  showId?: string;
};

/**
 * The integrations this Show can insert a link to, in the state that makes the
 * link work. Read off the **public** Show payload — the same copy
 * `useRedirectToExternalLink` judges the finished link by, so the toolbar and
 * the link cannot drift apart.
 *
 * Show-scoped on purpose: the library has no config to read and offers
 * `ALL_EXTERNAL_CONTROLS` instead.
 */
const useRichTextIntegrationControls = ({
  showId,
}: Args = {}): ExternalControlType[] => {
  const [show] = useCurrentPublicShow({ showId });
  const [jetConfig] = useJet({ showId: showId ?? show?.id });

  return useMemo(
    () =>
      [
        show?.expoPlatform?.type === ExpoPlatformType.Pushing
          ? ExternalControlType.expoPlatform
          : undefined,
        show?.asp?.type === AspType.Pushing
          ? ExternalControlType.asp
          : undefined,
        show?.visit?.type === VisitType.Pushing
          ? ExternalControlType.visit
          : undefined,
        show?.aditus?.type === AditusType.Pushing
          ? ExternalControlType.aditus
          : undefined,
        show?.sitka?.type === SitkaType.SSO
          ? ExternalControlType.sitka
          : undefined,
        // JET is the one integration missing from the Show payload.
        jetConfig?.type === JetType.Pushing && !jetConfig?.lastError
          ? ExternalControlType.jet
          : undefined,
      ].filter(filterNotEmptyArray),
    [show, jetConfig]
  );
};

export default useRichTextIntegrationControls;
